import React from 'react';
import BlockImage from './BlockImage';
import { ArticleTextWideImage } from '../../../../ArticleImage/ArticleTextWideImage';
import { CloudinaryImageType } from '../../../../../../../types/CloudinaryImageType';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ImageSerializerProps {
  value: { image: CloudinaryImageType; mobileImage?: CloudinaryImageType };
}

const Image = ({ value: { image } }: ImageSerializerProps) => <BlockImage image={image} />;

export const WideImageSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value: { image, mobileImage } }: ImageSerializerProps) => (
      <ArticleTextWideImage image={image} mobileImage={mobileImage} />
    );
  }
  return ({ value }: ImageSerializerProps) => <Image value={value} />;
};
